<template>
	<div>
		<loader />
		<popup-detail 
			id_ref="warning_qr"
    	direction="bottom" 
    	:show="warning.show"
    	use_max_size
    	wrapper_size="mobile"
    	use_footer
    	no_close_backdrop
    	@close="toggleWarning">
    	<template v-slot:body>
    		<div class="py-5 px-4 text-center">
    			<img-default />
	    		<p class="w-75 mt-4 mx-auto body-2-2">{{warning.message}}</p>
	    	</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
	    		<template v-if="warning.type == 'change_room'">
	    			<div class="row slim-grid-row">
	    				<div class="col-6">
	    					<button 
	    						@click="backToHome"
									class="g-btn g-btn-dark g-btn-lg w-100" >
									Cancel
								</button>
	    				</div>
	    				<div class="col-6">
	    					<state-button size="lg" variant="primary" block :click="changeRoom">
	    						Change the Room
	    					</state-button>
	    				</div>
	    			</div>
	    		</template>
	    		<button 
	    			v-else
	    			@click="backToHome"
						class="g-btn g-btn-primary g-btn-lg w-100" >
						Homepage
					</button>
				</div>
	    </template>
    </popup-detail>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {get,post} from '@/services/index.js';
	import WarningBox from '@/components/general/WarningBox'

	export default{
		components:{
			WarningBox
		},
		data(){
			return{
				error: '',
				warning:{
					show: false,
					type: '',
					message: ''
				},
				page_data:{
					room: {}
				}
			}
		},
		computed:{
			...mapGetters(['getMerchant','getRestaurantAuth','getConciergeReservation']),
			query(){
				return this.$route.query
			}
		},
		mounted(){
			this.loadFirstData()
		},
		methods:{
			...mapMutations(['setRoomStay','setRestaurantAuth','setConciergeReservationPerKey', 'setMembershipReferral']),
			loadFirstData(){
				if(this.query.type){
					if(this.query.type == 'general'){
						let is_referral_valid = this.query.member_code && this.query.reward_id
						if(is_referral_valid){
							this.setMembershipReferral({
								membership_referral_code: this.query.member_code,
								membership_reward_id: this.query.reward_id
							})
							setTimeout(() => {
								this.$router.push({
									path: `/${this.getMerchant.code}/booking`
								})
							}, 100);
						} else this.setWarning()
					} else if(this.query.type == 'hotel'){
						if(this.query.room_id){
							if(!this.getConciergeReservation.room.id){
								this.loadRoomDetail().then(res=>{
									this.$logout()
									this.setConciergeReservationPerKey([{
										key: 'room',
										value: res
									}])
									setTimeout(()=>{
										this.backToHome()
									},500)
								})
							}else{
								if(this.getConciergeReservation.room.id == this.query.room_id){
									this.backToHome()
								}else{
									this.setWarning('change_room')
								}
							}
						} else this.setWarning()
					} else if(this.query.type == 'restaurant'){
						if(this.query.session){
							this.runSession()
						}else if(this.query.table_number){
							this.saveTableNumberToVuex()
						}
					}
				}else{
					this.setWarning()
				}
			},
			backToHome(){
				this.$router.push({
					path: '/'+this.getMerchant.code
				})
			},
			toggleWarning(){
				this.warning.show = !this.warning.show
				if(!this.warning.show){
					this.warning_type = ''
					this.warning.message = ''
				}
			},
			setWarning(warning_type='invalid_url',warning_msg='Invalid URL. Please check again'){
				if(warning_type == 'change_room'){
					this.loadRoomDetail().then(res=>{
						this.warning.type = warning_type
						this.warning.message = `You have an active reservation with room ${this.getConciergeReservation.room.name}, while the room you scanned is ${res.name}, do you want to change it?`
						this.page_data.room = res
					}).catch(err=>{
						this.warning_type = 'invalid_room'
						this.warning.message = err
					}).finally(()=>{
						this.warning.show =  true
					})
				}else{
					this.warning_type = warning_type
					this.warning.message = warning_msg
					this.warning.show =  true
				}
			},
			changeRoom(){
				return new Promise((success,fail)=>{
					this.$logout()
					this.setConciergeReservationPerKey([{
						key: 'room',
						value: this.page_data.room
					}])
					setTimeout(()=>{
						this.backToHome()
						success()
					},500)
				})
			},

			// ROOM DETAIL
			loadRoomDetail(){
				return new Promise((success,fail)=>{
					get("CORE_HOTEL",`room/${this.query.room_id}`).then(response=>{
						let res = response.data
						if(res.success){
							success(res.data)
						}else{
							fail(res.message)
						}
					})
				})
			},

			// RESTAURANT SESSION
				runSession(query){
					if(this.getRestaurantAuth.session != ''){
						if(this.getRestaurantAuth.session == query.session){
							this.validateSession()
						}else{
							this.endSession()
						}
					}else{
						this.activateSession()
					}
				},
				validateSession(session){
					get("CORE_RESTO", "v2/session/validate",{
				    merchant_id: this.getMerchan.id
					},'restaurant_session').then(response=>{
						let res = response.data;
						if(res.success){
							this.backToHome()
						}else{
							this.setSessionToLocal()
							this.setWarning('invalid_resto_session',res.message)
						}
					})
				},
				activateSession(){
					this.setSessionToLocal()
					post("CORE_RESTO", "v2/session/activate",{
				    table_number: this.query.table_number ? this.query.table_number : '',
						name: this.query.name ? this.query.name : '',
						name: this.query.email ? this.query.email : '',
						name: this.query.phone_number ? this.query.phone_number : '',
				    merchant_id: this.getMerchant.id
					},'restaurant_session').then(response=>{
						let res = response.data;
						if(res.success){
							this.backToHome()
						}else{
							this.setSessionToLocal()
							this.setWarning('invalid_resto_session',res.message)
						}
					})
				},
				endSession(){
					post("CORE_RESTO", "v2/session/close",{},'restaurant_session').then(response=>{
						let res = response.data;
						if(res.success || (!res.success && res.message=='session expired')){
							this.activateSession()
						}else{
							this.setWarning('invalid_resto_session',res.message)
						}
					})
				},
				setSessionToLocal(is_reset=true){
					let params = is_reset ? 'reset' : [
						{
							key: 'session',
			    		value: this.query.session
						},
						{
							key: 'type',
							value: 'dynamic'
						}
					]
					if(!is_reset){
						if(this.query.name){
							params.push({
								key: 'name',
								value: this.query.name
							})	
						}
						if(this.query.email){
							params.push({
								key: 'email',
								value: this.query.email
							})	
						}
						if(this.query.phone_number){
							params.push({
								key: 'phone_number',
								value: this.query.phone_number
							})	
						}
						if(this.query.table_number){
							params.push({
								key: 'table_number',
								value: this.query.table_number
							})	
						}
					}
					this.setRestaurantAuth(params)
				},

			// RESTAURANT TABLE NUMBER
				saveTableNumberToVuex(){
					let params = [
						{
							key: 'table_number',
			    		value: this.query.table_number	
						},
						{
							key: '	type',
							value: 'static'
						},
						{
							key: 'setRestaurantAuth',
							value: true
						}
					]
					this.setRestaurantAuth(params)
					let self = this
					setTimeout(()=>{
						self.backToHome()
					},1000)
				}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/general/ApplyFromQR.vue